import { z } from "zod"

export const territoryItemSchema = z.object({
  /** Unique Genability ID for each territory item */
  territoryItemId: z.number().int(),
  /** The type of this territory item */
  territoryType: z.enum([`STATE`, `COUNTY`, `CITY`, `ZIPCODE`]).nullable(),
  /** The name of the territory item */
  value: z.string().nullable(),
  /** If true, this territory item is not
   * included as part of the coverage area of
   * the parent territory */
  exclude: z.boolean().nullable(),
  /** If true, then only a partial area of this
   * territory item is covered by this LSE */
  partial: z.boolean().nullable(),
})

export type TerritoryItem = z.infer<typeof territoryItemSchema>
